import { createCRUDEntity } from '../crud-factory';
import { transformBlogPostData } from '../transformations';

// BlogPost Entity
export const BlogPost = createCRUDEntity('blog_posts', transformBlogPostData);
